import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import "./Qualifications.scss";
import _ from "lodash";
import Helmet from "react-helmet";
import {config} from "../../../../config";
import CategoriesModeTinder from "./Components/CategoriesModeTinder/CategoriesModeTinder";
import CategoriesModeVideo from "./Components/CategoriesModeVideo/CategoriesModeVideo";
import {PageLoader} from "../../../components/Loader";
//import CategoriesModeList from "./Components/CategoriesModeList/CategoriesModeList";
//import pictureArrowSmallRight from "./images/arrow-small-right.png";
//import pictureLabel from "./images/label.png";
//import Icon from "../../../components/Icon";


class TagModerationQualifications extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayCategory : "temperature"
        }
    }


    render() {
        let isInitialized = this.props.categoriesModeTinderInitialized && this.props.categoriesModeVideoInitialized;
        return(
            <div id="taggage-media">
                <Helmet>
                    <title>{config.preTitle} Tag Moderations {config.postTitle}</title>
                </Helmet>
                {!isInitialized ? (
                    <section className="taggage-media container spin">
                        <PageLoader />
                    </section>
                ) : null}
                <section className={`taggage-media container ${!isInitialized ? "hidden" : ""}`}>

                    <div className={"taggage-media-navigation"}></div>
                    {/*<a href="/" className="taggage-media-navigation">
                        <img src={pictureArrowSmallRight} alt="" />
                        <p>Précédent</p>
                    </a>*/}

                    <div className={`taggage-media-main`}>
                        <p className="taggage-media-main-content-description mb-16">Bonjour <strong>{_.get(this.props.currentUser, 'username') || ""}</strong>,
                            merci pour votre participation à l'effort collectif ! Sachez qu'un <a
                                href="https://discord.gg/uPyrRfRgKT" rel="nofollow noopener noreferrer" target="_blank" className={"link-discord"}>chat Discord</a> a
                            été créé pour discuter du taggage et avoir un peu de convivialité entre volontaires. Voissa
                            c'est vous et grâce à vous !</p>
                        {/*<div className="taggage-media-main-setting">
                            <p>
                                <img src={pictureLabel} alt={""} />TAGGAGE DES MÉDIAS SUR VOISSA
                            </p>
                            <h1>Liberté-Sécurité-Plaisir</h1>
                            <div className="taggage-media-main-setting-cta">
                                <a href="/" className="active">
                                    <Icon type={"star"} size={"w-20"} className={"mr-10"} />
                                    Nouveaux contenus</a>
                                <a href="/">
                                    <Icon type={"archive-2"} size={"w-20"} className={"mr-10"} />
                                    Archives</a>
                            </div>
                        </div>*/}


                        <div className={`taggage-media-main-content`} style={{margin:"auto"}}>
                            <CategoriesModeTinder
                                currentUrl={this.props.match.url}
                            />
                            <CategoriesModeVideo currentUrl={this.props.match.url}  />
                        </div>
                    </div>

                </section>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser.data,
        currentUserInitialized : state.currentUser.initialized,
        currentUserLoading : state.currentUser.loading,

        categoriesModeTinderInitialized : state.categoriesModeTinder.initialized,
        categoriesModeVideoInitialized : state.categoriesModeVideo.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({

}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TagModerationQualifications);